import { im, USER_ID_KEY } from "@core/ability";
import { useEffect } from "react";
import loginStore from "@/store/login.store";
import userInfoStore from "@/store/user.store";
import { useNavigate } from "react-router-dom";
import summaryCommonStore from "@/store/summaryCommon.store";
import { setLoginSize } from "@/utils/window";
import { message } from "antd";
import { CompanyErrorTopic } from "@/constants/im";
import { IS_PRIVATE } from "@/config";

export const useIM = () => {
  const navigate = useNavigate();
  const hasLogin = loginStore((state) => state.hasLogin);
  const userId = userInfoStore((state) => state.userId);

  useEffect(() => {
    // 需要登录登录之后
    console.log("useIM hasLogin", hasLogin, userId);
    if (!hasLogin || !userId) return;
    
    // 私有化状态下不连接IM
    if (IS_PRIVATE) {
      console.log("Private mode: skipping IM initialization");
      return;
    }
    
    localStorage.setItem(USER_ID_KEY, userId);

    im.connect();

    // eslint-disable-next-line @typescript-eslint/no-explicit-any
    const companyErrorTopicCb = (message: any) => {
      console.log(`useIM onmessage ${CompanyErrorTopic}`, message);
      handleCompanyError();
    };

    // 监听当前登录企业被踢出，则重新跳转到登录页选择组织
    im.subscribe(CompanyErrorTopic, companyErrorTopicCb);

    const handleCompanyError = () => {
      message.error(`权限发生变更,请重新选择企业/组织`);
      setLoginSize();
      navigate("/login?mode=choseCompany&disableAutoJumpHome=true", {
        replace: true,
      });
      summaryCommonStore.getState().setShowCompanyError(true);
    };
    return () => {
      console.log("useIM unsubscribe");
      im.unsubscribe(CompanyErrorTopic, companyErrorTopicCb);
      im?.disconnect();
    };
  }, [hasLogin, navigate, userId]);
};
